import { OnlineContactFormController } from "./OnlineContactFormController";
import { QrWaiterContactFormController } from "./QrWaiterContactFormController";
export const ContactFormController = {
    fromContactDetails(contactDetails) {
        switch (contactDetails.type) {
            case "Online":
                return new OnlineContactFormController({ contactDetails });
            case "QRWaiter":
                return new QrWaiterContactFormController({ contactDetails });
            case "VoiceOrder":
                // Voice orders don't use form controllers - they use the voice agent directly
                throw new Error("ContactFormController not available for VoiceOrder - use voice agent instead");
        }
    },
};
export const ContactFormControllerToken = "ContactFormController";
